import { useQueryClient } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { router } from "../router"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import { useTranslations } from "../utils/use-t"

export function Router() {
  const {
    data: { permittedRoutes },
  } = useSuspenseQueryGet("/api/NavigationTree/GetNavigationInfo", null)

  const { t } = useTranslation("app_server")
  const ts = useTranslations()
  const queryClient = useQueryClient()

  const { data: authStatus } = useSuspenseQueryGet(
    "/api/Authentication/GetAuthStatus",
    null
  )

  const navigate = router.navigate
  return (
    <RouterProvider
      router={router}
      context={{ permittedRoutes, t, ts, queryClient, authStatus, navigate }}
    />
  )
}
